import {OptimizerConstraints, OptimizerConstraintsDTO} from '../../../interfaces/api'
import {useUrlParam} from '../../useUrlParam'
import {usePlannerQuery} from '../usePlannerQuery'

const selector = (constraintsDTO: OptimizerConstraintsDTO): OptimizerConstraints => ({
  assets: constraintsDTO.assets,
  operationModes: constraintsDTO.operation_modes,
  combinedMarkdown: constraintsDTO.combined_markdown
})

export const useOptimizerConstraints = () => {
  const plantCode = useUrlParam('plantCode')

  return usePlannerQuery('optimizerConstraints', [plantCode], {
    select: selector
  })
}
